<div class="smidemenu-container">
    <ul class="menu">
        <li *ngFor="let m of menus">
            <a mat-button [matTooltip]="m.label" matTooltipPosition="right" (click)="onSelectSidemenuOption(m.label)"  [class.active]="m.label == selectedSection">  <i class="mdi" [class]="m.icon"></i></a> 
        </li> 
    </ul>
</div>
